interface AccountsConfig {
  url: string;
}

interface ApiConfig {
  base: string;
  v1: string;
  v2: string;
}

interface ImagesConfig {
  url: string;
}

interface MapBoxConfig {
  accessToken: string;
}

interface WebConfig {
  v1: string;
}

interface AppConfig {
  accounts: AccountsConfig;
  api: ApiConfig;
  images: ImagesConfig;
  mapbox: MapBoxConfig;
  web: WebConfig;
}

export const Config: AppConfig = {
  accounts: {
    url: window._env_.ACCOUNTS_URL,
  },
  api: {
    base: `${window._env_.API_URL}`,
    v1: `${window._env_.API_URL}/api/v1`,
    v2: `${window._env_.API_URL}/api/v2`,
  },
  images: {
    url: `${window._env_.IMAGES_URL}`,
  },
  mapbox: {
    accessToken: window._env_.MAPBOX_ACCESSTOKEN,
  },
  web: {
    v1: `${window._env_.WEB_URL}`,
  },
};
